import React, {
    useEffect,
    useState,
  } from "react";
  
  import axios from "axios";
  import Swal from "sweetalert2";
  import { saveAs } from "file-saver";
  
  import exportValue from "../apiconfig";
import Left_panel from "./Left_panel";
import Sub_header from "./Sub_header";
  
  const  ClientPricing = ()=> {
  
    const [customerList, setCustomerList] = useState([]);
  
    const [loading, setLoading] = useState(false);
  
    const [selectedCustomers, setSelectedCustomers] =
      useState([]);
      const [pricingFilter, setPricingFilter] = useState("ALL");
    const [pricingFile, setPricingFile] = useState(null);
const [pricingRemarks, setPricingRemarks] = useState("");
const [pricingLoading, setPricingLoading] = useState(false);

const [selectedCustomer, setSelectedCustomer] = useState({});
const [isBulkUpload, setIsBulkUpload] =
useState(false);
const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
        homeSection.classList.toggle('sidebar-closed');
    }
};
    useEffect(() => {
      getCustomerPricingList();
    }, []);
  
    const getCustomerPricingList = () => {
  
      setLoading(true);
  
      let full_api =
        exportValue.host +
        "/" +
        exportValue.version +
        "/" +
        exportValue.api +
        "/client_pricing_list";
  
      axios
        .post(
          full_api,
          {},
          {
            headers: exportValue.headers,
          }
        )
        .then((res) => {
  
          setLoading(false);
  
          if (res.data.status) {
            setCustomerList(
              res.data.data
            );
          }
        })
        .catch(() => {
          setLoading(false);
        });
    };
  
    const selectAll = (e) => {
  
      if (e.target.checked) {
  
        setSelectedCustomers(
          filteredCustomers.map(
            (x) => x.customer_id
          )
        );
  
      } else {
  
        setSelectedCustomers([]);
  
      }
    };
  
    const selectSingle = (
      customer_id
    ) => {
  
      if (
        selectedCustomers.includes(
          customer_id
        )
      ) {
  
        setSelectedCustomers(
          selectedCustomers.filter(
            (x) =>
              x !== customer_id
          )
        );
  
      } else {
  
        setSelectedCustomers([
          ...selectedCustomers,
          customer_id,
        ]);
  
      }
    };
  
    const openUploadModal = (customer) => {

        setIsBulkUpload(false);
      
        setSelectedCustomer(customer);
      
        setPricingFile(null);
      
        setPricingRemarks("");
      
        const modal =
          new window.bootstrap.Modal(
            document.getElementById(
              "bulkUploadPricingModal"
            )
          );
      
        modal.show();
      };
  
      const downloadSample =
      async () => {
      
        try{
      
          const sendData = {
            customer_id:
            isBulkUpload
            ?
            ""
            :
            selectedCustomer.customer_id
          };
      
          let full_api =
            exportValue.host +
            "/" +
            exportValue.version +
            "/" +
            exportValue.api +
            "/download_bulk_pricing_excel_customer";
      
          const response =
            await axios.post(
              full_api,
              sendData,
              {
                headers:
                exportValue.headers,
                responseType:
                "blob"
              }
            );
      
            const blob = new Blob(
                [response.data],
                {
                  type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                }
              );
              
              saveAs(
                blob,
                "Sample_Rate_Card.xlsx"
              );
      
        }
        catch(e){
      
          Swal.fire({
            icon:"error",
            title:"Unable to download sample"
          });
      
        }
      
      };
  
    const downloadSummary =
      async () => {
        try{
        let full_api =
          exportValue.host +
          "/" +
          exportValue.version +
          "/" +
          exportValue.api +
          "/client_pricing_summary_excel";
  
        const response =
          await axios.post(
            full_api,
            {},
            {
              headers:
                exportValue.headers,
              responseType:
                "blob",
            }
          );
  
          const blob = new Blob(
            [response.data],
            {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }
          );
          
          saveAs(
            blob,
            "Client_Pricing.xlsx"
          );
        }
        catch(e){
      
          Swal.fire({
            icon:"error",
            title:"Unable to download summary"
          });
      
        }
      };
  
      const uploadSinglePricing = async () => {
        try {
      
          if (!pricingFile) {
            Swal.fire({
              icon: "error",
              title: "Please select excel file",
            });
            return;
          }
      
          setPricingLoading(true);
      
          const formData = new FormData();
      
          formData.append(
            "file",
            pricingFile
          );
      
          formData.append(
            "customer_id",
            selectedCustomer.customer_id
          );
      
          formData.append(
            "remarks",
            pricingRemarks
          );
      
        
      
          const full_api =
            exportValue.host +
            "/" +
            exportValue.version +
            "/" +
            exportValue.api +
            "/upload_bulk_pricing_excel_customer";
      
          const response = await axios.post(
            full_api,
            formData,
            {
              headers: {
                ...exportValue.headers,
                "Content-Type": "multipart/form-data",
              },
            }
          );
      
          setPricingLoading(false);
      
          if (response.data.status) {
      
            const modal =
              document.getElementById(
                "bulkUploadPricingModal"
              );
      
            if (modal) {
              const instance =
                window.bootstrap.Modal.getInstance(
                  modal
                );
      
              if (instance) {
                instance.hide();
              }
            }
      
            Swal.fire({
              icon: "success",
              title: "Pricing Uploaded Successfully",
            });
      
            setTimeout(() => {
              window.location.reload();
            }, 1000);
      
          } else {
      
            Swal.fire({
              icon: "error",
              title: response.data.message,
            });
      
          }
      
        } catch (e) {
      
          console.log(e);
      
          setPricingLoading(false);
      
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
          });
      
        }
      };

      const uploadBulkPricing = async () => {
        try {
      
          if (!pricingFile) {
            Swal.fire({
              icon: "error",
              title: "Please select excel file",
            });
            return;
          }
      
          if (selectedCustomers.length === 0) {
            Swal.fire({
              icon: "error",
              title: "Please select sellers",
            });
            return;
          }
      
          setPricingLoading(true);
      
          const formData = new FormData();
      
          formData.append(
            "file",
            pricingFile
          );
      
          formData.append(
            "customer_ids",
            JSON.stringify(selectedCustomers)
          );
      
          formData.append(
            "remarks",
            pricingRemarks
          );
      
       
      
          const full_api =
            exportValue.host +
            "/" +
            exportValue.version +
            "/" +
            exportValue.api +
            "/upload_bulk_pricing_excel_customer";
      
          const response = await axios.post(
            full_api,
            formData,
            {
              headers: {
                ...exportValue.headers,
                "Content-Type":
                  "multipart/form-data",
              },
            }
          );
      
          setPricingLoading(false);
      
          if (response.data.status) {
      
            const modal =
              document.getElementById(
                "bulkUploadPricingModal"
              );
      
            if (modal) {
              const instance =
                window.bootstrap.Modal.getInstance(
                  modal
                );
      
              if (instance) {
                instance.hide();
              }
            }
      
            Swal.fire({
              icon: "success",
              title:
                "Pricing Uploaded Successfully",
            });
      
            setTimeout(() => {
              window.location.reload();
            }, 1000);
      
          } else {
      
            Swal.fire({
              icon: "error",
              title: response.data.message,
            });
      
          }
      
        } catch (e) {
      
          console.log(e);
      
          setPricingLoading(false);
      
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
          });
      
        }
      };

     
      const openBulkUploadModal = () => {

        setIsBulkUpload(true);
      
        setSelectedCustomer({});
      
        setPricingFile(null);
      
        setPricingRemarks("");
      
        const modal =
          new window.bootstrap.Modal(
            document.getElementById(
              "bulkUploadPricingModal"
            )
          );
      
        modal.show();
      
      };

  const resetSinglePricing = (
    customer_id
  ) => {
  
    Swal.fire({
      title:
        "Are you sure?",
      text:
        "You want to reset custom pricing?",
      icon:
        "warning",
      showCancelButton:
        true,
    }).then(
      (
        result
      ) => {
  
        if (
          result.isConfirmed
        ) {
  
          let full_api =
            exportValue.host +
            "/" +
            exportValue.version +
            "/" +
            exportValue.api +
            "/reset_client_pricing";
  
            axios.post(
                full_api,
                {
                  customer_ids: [
                    customer_id,
                  ],
                },
                {
                  headers:
                    exportValue.headers,
                }
              )
              .then(() => {
              
                Swal.fire({
                  icon: "success",
                  title: "Pricing Reset Successfully",
                });
              
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              
              })
              .catch(() => {
              
                Swal.fire({
                  icon: "error",
                  title: "Unable to reset pricing",
                });
              
              });  
        }
  
      }
    );
  
  };

  const bulkResetPricing =
  () => {

    Swal.fire({
      title:
        "Are you sure?",
      text:
        "You want to reset custom pricing?",
      icon:
        "warning",
      showCancelButton:
        true,
    }).then(
      (
        result
      ) => {

        if (
          result.isConfirmed
        ) {

          let full_api =
            exportValue.host +
            "/" +
            exportValue.version +
            "/" +
            exportValue.api +
            "/reset_client_pricing";

          axios.post(
            full_api,
            {
              customer_ids:
                selectedCustomers,
            },
            {
              headers:
                exportValue.headers,
            }
          )
          .then(
            () => {

              Swal.fire({
                icon:
                  "success",
                title:
                  "Pricing Reset Successfully",
              });

              setTimeout(
                () => {
                  window.location.reload();
                },
                1000
              );

            }
          ).catch(() => {

            Swal.fire({
              icon: "error",
              title: "Unable to reset pricing",
            });
          
          });

        }

      }
    );

  };

  const filteredCustomers = customerList.filter((item) => {

    if (pricingFilter === "ALL") return true;
  
    if (pricingFilter === "CUSTOM") {
      return item.pricing_type === "CUSTOM";
    }
  
    if (pricingFilter === "SYSTEM") {
      return item.pricing_type === "SYSTEM";
    }
  
    return true;
  });
    return (
        <div>
        <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <section class="home-section">
          
            <Sub_header />
      <div className="container-fluid mt-1">
  
        <div className="card">
  
          <div className="card-header">
  
            <h3>
              Client Pricing
            </h3>
  
            <div>
  
              {
                selectedCustomers
                  .length >
                  0 && (
                  <div className="dropdown d-inline me-2">
  
                    <button
                      className="btn btn-primary dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      Bulk Actions
                    </button>
  
                    <ul className="dropdown-menu">
  
                    <li>
  <button
    className="dropdown-item"
    onClick={
      bulkResetPricing
    }
  >
    Reset
  </button>
</li>
  
<li>
  <button
    className="dropdown-item"
    onClick={
      openBulkUploadModal
    }
  >
    Upload
  </button>
</li>
  
                    </ul>
  
                  </div>
                )
              }
              <select
    className="form-select d-inline-block me-2"
    style={{width:"180px"}}
    value={pricingFilter}
    onChange={(e)=>setPricingFilter(e.target.value)}
>

    <option value="ALL">
        All Pricing
    </option>

    <option value="CUSTOM">
        Custom
    </option>

    <option value="SYSTEM">
        System
    </option>

</select>
  
              <button
                className="btn btn-success"
                onClick={
                  downloadSummary
                }
              >
                Download
              </button>
  
            </div>
  
          </div>
  
          <div className="table-responsive">
  
            <table className="table table-bordered">
  
              <thead>
  
                <tr>
  
                  <th>
  
                  <input
type="checkbox"
checked={
  filteredCustomers.length > 0 &&
selectedCustomers.length === filteredCustomers.length
}
onChange={selectAll}
/>
  
                  </th>
  
                  <th>
                    JP ID
                  </th>
  
                  <th>
                    Seller Name
                  </th>
  
                  <th>
                    Pricing
                  </th>
  
                  <th>
                    Actions
                  </th>
  
                  <th>
                    Rate Card
                  </th>
  
                  <th>
                    Remarks
                  </th>
  
                </tr>
  
              </thead>
  
              <tbody>
  
                {
                  filteredCustomers.map(
                    (
                      item,
                      index
                    ) => (
                      <tr
                        key={
                          index
                        }
                      >
  
                        <td>
  
                          <input
                            type="checkbox"
                            checked={selectedCustomers.includes(
                              item.customer_id
                            )}
                            onChange={() =>
                              selectSingle(
                                item.customer_id
                              )
                            }
                          />
  
                        </td>
  
                        <td>
                          {
                            item.jp_id
                          }
                        </td>
  
                        <td>
                          {
                            item.customer_name
                          }
                        </td>
  
                        <td>
  
                          <span
                            className={
                              item.pricing_type ===
                              "CUSTOM"
                                ? "badge bg-success"
                                : "badge bg-secondary"
                            }
                          >
                            {
                              item.pricing_type
                            }
                          </span>
  
                        </td>
  
                        <td>
  
                        <button
  className="btn btn-warning btn-sm me-2"
  onClick={() =>
    resetSinglePricing(
      item.customer_id
    )
  }
>
  Reset
</button>
  
<button
  className="btn btn-success"
  onClick={() =>
    openUploadModal(item)
  }
>
  
    Upload
  
</button>
  
                        </td>
  
                        <td>
  
                        {
item.rate_card_url
?
<a
href={
item.rate_card_url
}
target="_blank"
rel="noopener noreferrer"
download
>
{
item.file_name
||
"Download"
}
</a>
:
"-"
}
  
                        </td>
  
                        <td>
                          {
                            item.remarks
                          }
                        </td>
  
                      </tr>
                    )
                  )
                }
  
              </tbody>
  
            </table>
  
          </div>
  
        </div>
  
        {/* Upload Modal */}
  
        <div
          className="modal fade"
          id="bulkUploadPricingModal"
          data-bs-backdrop="false"
        >
  
          <div className="modal-dialog">
  
            <div className="modal-content">
  
              <div className="modal-header">
  
              <h5>
{
isBulkUpload
?
"Bulk Upload Rate Card"
:
"Upload Rate Card"
}
</h5>
  
                <button
                  className="btn-close"
                  data-bs-dismiss="modal"
                />
  
              </div>
  
              <div className="modal-body">
  
                <div className="mb-3">
  
                  <label>
                    Excel File
                  </label>
  
                  <input
                    type="file"
                    className="form-control"
                    accept=".xlsx,.xls"
                    onChange={(
                      e
                    ) =>
                      setPricingFile(
                        e.target
                          .files[0]
                      )
                    }
                  />
  
                </div>
  
                <div className="mb-3">
  
                  <label>
                    Remarks
                  </label>
  
                  <textarea
                    className="form-control"
                    rows="3"
                    value={
                        pricingRemarks
                        }
                        onChange={
                        (e)=>
                        setPricingRemarks(
                        e.target.value
                        )
                        }
                  />
  
                </div>
  
                <button
                  className="btn btn-danger"
                  onClick={
                    downloadSample
                  }
                >
                  Download
                  Sample File
                </button>
  
              </div>
  
              <div className="modal-footer">
  
                <button
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
  
                <button
  className="btn btn-success"
  disabled={pricingLoading}
  onClick={() => {

    if (
      isBulkUpload
    ) {
      uploadBulkPricing();
    } else {
      uploadSinglePricing();
    }

  }}
>
  {
    pricingLoading
    ?
    "Uploading..."
    :
    "Upload"
  }
</button>
  
              </div>
  
            </div>
  
          </div>
  
        </div>
  
      </div>
      </section>
      </div>
    );
  }
  
  export default ClientPricing;